import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './AboutMe.css';

const AboutMe = () => {
    return (
        <section id="about" className="about-container pt-5 overflow-hidden">
            <Container>
                <Row className="align-items-center">

                    <Col
                        data-aos="fade-down-left"
                        xs={12} sm={12} md={7}>
                        <h2 className="about-title pt-5 ">About Me</h2>
                        <div className="line2 mb-3"></div>
                        <p className="summary">Determined Junior Developer with the ability to adapt in both self-starting and collaborative environments.
                            <br />
                            <span className="d-inline-block my-3">
                                Specialize in Designing, Developing, and Debugging. Passionate about building first-class web applications. I always love to do clean and reusable code.
                            </span>
                        </p>
                        <div className="w-75">
                            <ul>
                                <li>
                                    <p className="stack">
                                        <span className="stack-title">Front-End:</span> <br /> HTML, CSS, Bootstrap, Tailwind, Material/UI, JavaScript, ES6, React Js
                                    </p>
                                </li>
                                <li>
                                    <p className="stack">
                                        <span className="stack-title">Back-End:</span> <br /> MongoDB, Express Js, Node Js, RestAPI
                                    </p>
                                </li>
                                <li>
                                    <p className="stack">
                                        <span className="stack-title">Tools:</span> <br />Git, Google Chrome, VS Code, Netlify, Heroku, Figma, Photoshop
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <a href="#contact">
                            <button className="primary-button mt-3">Get In Touch</button>
                        </a>
                    </Col>
                    <Col
                        data-aos="fade-down-right"
                        xs={12} sm={12} md={5}>
                        <img className="img-fluid" src="https://i.ibb.co/WKhxyFD/e-Copy-2.png" alt="" />
                    </Col>

                </Row>
                <div className="d-flex align-items-center justify-content-center icon py-5">
                        <div className="">
                            <a href="https://www.linkedin.com/in/antor7080/" target="_blank" rel="noreferrer">
                                <i className="fab fa-linkedin-in"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="https://twitter.com/antor7080" target="_blank" rel="noreferrer">
                                <i className="fab fa-twitter"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="https://github.com/Antor7080" target="_blank" rel="noreferrer">
                                <i className="fab fa-github"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="https://fb.com/antor15" target="_blank" rel="noreferrer">
                                <i className="fab fa-facebook"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="mailto:antor7080@gmail.com" target="_blank" rel="noreferrer">
                                <i className="fas fa-envelope"></i>
                            </a>
                        </div>
                    </div>
            </Container>
        </section>
    );
};

export default AboutMe;